import { DeleteTemplateCategory, DeleteTemplateCategoryVariables } from './__generated__/DeleteTemplateCategory'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation DeleteTemplateCategory($input: DeleteTemplateCategoryInputV2!) {
    deleteTemplateCategory: deleteTemplateCategoryV2(input: $input) {
      ... on TemplateCategoryV2 {
        id
        title
      }
      ... on TemplateCategoryErrorV2 {
        type
        error
      }
    }
  }
`

export const useDeleteTemplateCategory = () =>
  useMutation<DeleteTemplateCategory, DeleteTemplateCategoryVariables>(MUTATION)
